import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { UserService} from '../core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from '../auth/custom-validator';
import AuthUtil from '../core/utils/auth.util';
import {MessageService} from 'primeng/api';
import {ErrorUtil} from '../core/utils/error.util';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-password-reset-page',
    templateUrl: './password-reset.component.html',
    providers: [MessageService]
})
export class PasswordResetComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private fb: FormBuilder,
        private messageService: MessageService,
        private translate: TranslateService
    ) { }

    isSubmitting = false;
    authForm: FormGroup;
    serverErrorId = null;
    token = null;
    passwordResetted = false;
    get f() {
        return this.authForm.controls;
    }
    ngOnInit() {
        this.route.url.subscribe(next => {
            this.setupRooting();
        });
        this.authForm = this.fb.group({
            'newPassword': ['', Validators.required],
            'newPasswordConfirm': ['', Validators.required]
        });
        this.authForm.setValidators(CustomValidators.mustMatch('newPassword', 'newPasswordConfirm'));
    }

    setupRooting() {
        const routerParams = this.router.url.split('/');
        this.token = routerParams[2];
    }

    logout() {
        this.userService.purgeAuth();
        this.router.navigateByUrl('/');
    }

    submitPasswordForm() {
        this.isSubmitting = true;
        // stop here if form is invalid
        if (this.authForm.invalid) {
            return;
        }

        const pwd = this.authForm.value.currentPassword;
        const newPwd = this.authForm.value.newPassword;
        const credentials = { 'token' : this.token, 'newPassword': AuthUtil.generateEncryptedPwd(newPwd)};
        this.userService
            .resetPassword(credentials)
            .subscribe(
                data => {
                    if (data.ok === true) {
                        this.passwordResetted = true;
                        this.isSubmitting = false;
                        this.messageService.add({severity: 'success', summary: this.translate.instant('password_reset_ok')});
                        this.authForm.reset();
                    }
                    return data;
                },
                err => {
                    this.serverErrorId = err['error'];
                    this.isSubmitting = false;
                    this.messageService.add({severity: 'error',
                        summary: this.translate.instant('error'),
                        detail: this.translate.instant(new ErrorUtil(this.serverErrorId).description)
                    });
                }
            );
    }
}
